export default __webpack_public_path__ + "static/media/excel.6ab3e8b9.png";